<ham-modal
    *ngIf="showModal"
    [title]="'aumico_projects_release_highlights_modal_title' | i18next"
    [titleIcon]="'new-icon'"
    [headerClass]="'announcement'"
    [bodyClass]="'no-overflow'"
    [saveText]="
        currentSlide < slides.length - 1
            ? ('aumico_projects_release_highlights_modal_next' | i18next)
            : ('aumico_projects_release_highlights_modal_got_it' | i18next)
    "
    [showCloseIcon]="true"
    [showCancelButton]="currentSlide !== 0 ? true : false"
    [cancelText]="currentSlide !== 0 ? ('aumico_projects_release_highlights_modal_previous' | i18next) : ''"
    [addHorizontalLineBeforeButtons]="true"
    [variant]="'grayfooter'"
    [progressTotal]="slides.length"
    [progressCurrent]="currentSlide + 1"
    [isCancelButtonDifferentFromCloseIcon]="true"
    (save)="currentSlide < slides.length - 1 ? nextSlide() : close()"
    (cancel)="close()"
    (cancelButtonExclusivelyClicked)="previousSlide()"
    size="lg"
>
    <div class="release-highlights-modal">
        <div class="slides-container">
            <div class="slide" *ngFor="let slide of slides; let i = index" [class.active]="i === currentSlide">
                <div class="text-column" [innerHTML]="slide.htmlContent | i18next"></div>
                <img [src]="slide.imageUrl" class="slide-image" (error)="onImageError($event)" />
            </div>
        </div>
    </div>
</ham-modal>
